export const COLS = [
  { key: 'operacao',            label: 'Operação',           kind: 'stage',  min: 90,  fr: 1,    align: 'center' },
  { key: 'cadastro',            label: 'Cadastro',           kind: 'stage',  min: 90,  fr: 1,    align: 'center' },
  { key: 'gro',                 label: 'GRO',                kind: 'stage',  min: 90,  fr: 1,    align: 'center' },
  { key: 'checklist',           label: 'Check-list',         kind: 'stage',  min: 90,  fr: 1,    align: 'center' },
  { key: 'negociacao',          label: 'Negociação',         kind: 'stage',  min: 100, fr: 1,    align: 'center' },
  { key: 'emissao',             label: 'Emissão',            kind: 'stage',  min: 90,  fr: 1,    align: 'center' },
  { key: 'status',              label: 'Status',             kind: 'status', min: 140, fr: 1,    align: 'center' },
  { key: 'ordemFila',           label: 'Ordem na fila',                      min: 50,  fr: 1,    align: 'center' },
  { key: 'viagem',              label: 'Viagem',                             min: 120, fr: 1,    align: 'center' },
  { key: 'tempoAtividade',      label: 'Tempo de atividade',                 min: 100, fr: 1,    align: 'center' },
  { key: 'tempoFila',           label: 'Tempo na fila',                      min: 100, fr: 1,    align: 'center' },
  { key: 'idadeViagem',         label: 'Tempo de liberação',                 min: 90,  fr: 1,    align: 'center' },
  { key: 'cliente',             label: 'Cliente',                            min: 150, fr: 1,    align: 'center' },
  { key: 'driverAndShipping',   label: 'Transportadora Motorista',           min: 180, fr: 1,    align: 'center' },
  { key: 'centroDeCusto',       label: 'Centro De Custo',                    min: 90,  fr: 1,    align: 'center' },
  { key: 'filial',              label: 'Filial',                             min: 80,  fr: 1,    align: 'center' },
  { key: 'veiculos',            label:'Veículos',                            min: 100,  fr: 1,   align: 'center' },
];

export const GRID_GAP = 1;

export const GRID_TEMPLATE = COLS
  .map(c => `minmax(${c.min || 100}px, ${c.fr || 1}fr)`)
  .join(' ');

export const MIN_TOTAL = COLS.reduce((acc, c) => acc + (c.min || 100), 0);

export const TOTAL_GAPS = GRID_GAP * (COLS.length - 1);

export const SIDE_PAD = 16;

export const GRID_SIDE_PADDING = SIDE_PAD * 2;

export const MIN_TOTAL_PADDED = MIN_TOTAL + TOTAL_GAPS + GRID_SIDE_PADDING;
